// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/img_contato.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ContactPage_contact__onJdA {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  min-height: 90vh;
  padding: 60px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.ContactPage_contact__onJdA::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.8) 0%, rgba(19, 35, 29, 0.1) 97%, rgba(0, 0, 0, 0) 100%, rgba(19, 35, 29, 0.3) 75%, rgba(0, 0, 0, 0.85) 100%);
  pointer-events: none;
}
.ContactPage_contact__wrapper__86THz {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  width: 100%;
  max-width: 1100px;
  gap: 40px;
  align-items: center;
}
@media (max-width: 992px) {
  .ContactPage_contact__wrapper__86THz {
    grid-template-columns: 1fr;
    max-width: 600px;
  }
}
.ContactPage_contact__info__ISav4 {
  color: #fff;
  padding-right: 40px;
}
@media (max-width: 992px) {
  .ContactPage_contact__info__ISav4 {
    padding-right: 0;
    text-align: center;
  }
}
.ContactPage_contact__eyebrow__dLjAb {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #82B194;
  margin-bottom: 12px;
}
.ContactPage_contact__title__9Jgmz {
  font-size: 52px;
  font-weight: 800;
  line-height: 1.02;
  letter-spacing: -0.04em;
  margin: 0 0 20px;
  color: #fff;
}
@media (max-width: 576px) {
  .ContactPage_contact__title__9Jgmz {
    font-size: 36px;
  }
}
.ContactPage_contact__description__EIBH2 {
  font-size: 18px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  max-width: 480px;
}
@media (max-width: 992px) {
  .ContactPage_contact__description__EIBH2 {
    margin: 0 auto;
  }
}
.ContactPage_contact__separator__l1hzd {
  width: 60px;
  height: 2px;
  background-color: #82B194;
  margin: 32px 0;
}
@media (max-width: 992px) {
  .ContactPage_contact__separator__l1hzd {
    margin: 32px auto;
  }
}
.ContactPage_contact__footer-text__0x083 {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7);
}
.ContactPage_contact__link__ku5zm {
  color: #82B194;
  text-decoration: none;
  font-weight: 700;
  transition: opacity 0.2s;
}
.ContactPage_contact__link__ku5zm:hover {
  opacity: 0.8;
  text-decoration: underline;
}
.ContactPage_contact__card__Vr1uT {
  background: rgba(247, 244, 239, 0.94);
  border: 1px solid rgba(19, 35, 29, 0.1);
  border-radius: 24px;
  box-shadow: 0 18px 48px rgba(19, 35, 29, 0.14);
  backdrop-filter: blur(12px);
  padding: 24px 20px;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}
@media (max-width: 576px) {
  .ContactPage_contact__card__Vr1uT {
    padding: 24px 20px;
    background: rgba(247, 244, 239, 0.98);
  }
}

.ContactPage_form__P3nUW {
  display: grid;
  gap: 10px;
}
.ContactPage_form__copy__1OO6N {
  margin: 0 0 8px;
  color: rgba(19, 35, 29, 0.78);
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}
.ContactPage_form__field-group__3k7d7 {
  display: flex;
  flex-direction: column;
}
.ContactPage_form__input__7Obr7 {
  width: 100%;
  min-height: 48px;
  border-radius: 14px;
  border: 1px solid rgba(19, 35, 29, 0.12);
  background: #fff;
  padding: 0 14px;
  color: #13231d;
  font-size: 14px;
  line-height: 1.4;
  transition: all 0.2s ease;
  outline: none;
}
.ContactPage_form__input__7Obr7::placeholder {
  color: rgba(19, 35, 29, 0.44);
}
.ContactPage_form__input__7Obr7:focus {
  border-color: #82B194;
  box-shadow: 0 0 0 4px rgba(130, 177, 148, 0.16);
}
.ContactPage_form__input--textarea__U8NOz {
  padding-top: 14px;
  resize: none;
  min-height: 100px;
}
.ContactPage_form__input--error__T42o1 {
  border-color: #C95C5C !important;
  background-color: rgba(201, 92, 92, 0.02);
}
.ContactPage_form__input--error__T42o1:focus {
  box-shadow: 0 0 0 4px rgba(201, 92, 92, 0.12) !important;
}
.ContactPage_form__input__7Obr7:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: #13231d !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
.ContactPage_form__input__7Obr7:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #e6ebe4 inset !important;
  -webkit-text-fill-color: #13231d !important;
}
.ContactPage_form__error-text__sSyFp {
  color: #C95C5C;
  font-size: 11px;
  margin-top: 4px;
  margin-left: 4px;
  font-weight: 700;
  text-align: left;
  animation: ContactPage_fadeIn__kUoRg 0.2s ease-in-out;
}
.ContactPage_form__button__E4mnC {
  width: 100%;
  margin-top: 10px;
  min-height: 48px;
  padding: 0 24px;
  border-radius: 16px;
  font-weight: 750;
  border: 1px solid transparent;
  background: #82B194;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  font-size: 15px;
}
.ContactPage_form__button__E4mnC:hover:not(:disabled) {
  background: #739F84;
  transform: translateY(-1px);
}
.ContactPage_form__button__E4mnC:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.ContactPage_form__message--error__rQJxF {
  color: #C95C5C;
  font-size: 13px;
  margin-top: 5px;
  text-align: center;
  font-weight: 600;
}

.ContactPage_success__--32Q {
  text-align: center;
  padding: 20px 0;
}
.ContactPage_success__icon__uKnoA {
  color: #82B194;
  margin-bottom: 16px;
}
.ContactPage_success__icon__uKnoA svg {
  font-size: 64px;
}
.ContactPage_success__title__bY9-k {
  font-size: 28px;
  font-weight: 800;
  color: #13231D;
  margin-bottom: 12px;
  letter-spacing: -0.02em;
}
.ContactPage_success__text__fMmKt {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(19, 35, 29, 0.68);
}

@keyframes ContactPage_fadeIn__kUoRg {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/ContactPage/ContactPage.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oFDNQ;ACuBZ;AAfI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mKAAA;EACA,oBAAA;AAiBR;AAdI;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,kCAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAgBR;AAdQ;EAVJ;IAWQ,0BAAA;IACA,gBAAA;EAiBV;AACF;AAdI;EACI,WAAA;EACA,mBAAA;AAgBR;AAdQ;EAJJ;IAKQ,gBAAA;IACA,kBAAA;EAiBV;AACF;AAdI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cD3Ce;EC4Cf,mBAAA;AAgBR;AAbI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAeR;AAbQ;EARJ;IASQ,eAAA;EAgBV;AACF;AAbI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;AAeR;AAbQ;EANJ;IAOQ,cAAA;EAgBV;AACF;AAbI;EACI,WAAA;EACA,WAAA;EACA,yBD1Ee;EC2Ef,cAAA;AAeR;AAbQ;EANJ;IAOQ,iBAAA;EAgBV;AACF;AAbI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAeR;AAZI;EACI,cDzFe;EC0Ff,qBAAA;EACA,gBAAA;EACA,wBAAA;AAcR;AAZQ;EACI,YAAA;EACA,0BAAA;AAcZ;AAVI;EACI,qCAAA;EACA,uCAAA;EACA,mBAAA;EACA,8CAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAYR;AAVQ;EAXJ;IAYQ,kBAAA;IACA,qCAAA;EAaV;AACF;;AARA;EACI,aAAA;EACA,SAAA;AAWJ;AATI;EACI,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAWR;AARI;EACI,aAAA;EACA,sBAAA;AAUR;AAPI;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;AASR;AAPQ;EACI,6BAAA;AASZ;AANQ;EACI,qBD1JW;EC2JX,+CAAA;AAQZ;AALQ;EACI,iBAAA;EACA,YAAA;EACA,iBAAA;AAOZ;AAJQ;EACI,gCAAA;EACA,yCAAA;AAMZ;AAJY;EACI,wDAAA;AAMhB;AAFQ;EACI,yDAAA;EACA,2CAAA;EACA,yDAAA;EAAA,iDAAA;AAIZ;AADQ;EACI,yDAAA;EACA,2CAAA;AAGZ;AACI;EACI,cDvKe;ECwKf,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qDAAA;AACR;AAEI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBD3Me;EC4Mf,WAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;AAAR;AAEQ;EACI,mBDlNW;ECmNX,2BAAA;AAAZ;AAGQ;EACI,YAAA;EACA,mBAAA;AADZ;AAKI;EACI,cD3Me;EC4Mf,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAHR;;AAOA;EACI,kBAAA;EACA,eAAA;AAJJ;AAMI;EACI,cD3Oe;EC4Of,mBAAA;AAJR;AAMQ;EACI,eAAA;AAJZ;AAQI;EACI,eAAA;EACA,gBAAA;EACA,cDzOe;EC0Of,mBAAA;EACA,uBAAA;AANR;AASI;EACI,eAAA;EACA,gBAAA;EACA,6BD/Oe;ACwOvB;;AAWA;EACI;IACI,UAAA;IACA,2BAAA;EARN;EAWE;IACI,UAAA;IACA,wBAAA;EATN;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n.contact {\n    background-image: url('../../assets/images/img_contato.jpeg');\n    background-size: cover;\n    background-position: center;\n    min-height: 90vh;\n    padding: 60px 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    font-family: $font-main;\n\n    &::before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        background: linear-gradient(to right, rgba(0, 0, 0, 0.8) 0%, rgba(19, 35, 29, 0.1) 97%, rgba(0, 0, 0, 0) 100%, rgba(19, 35, 29, 0.3) 75%, rgba(0, 0, 0, 0.85) 100%);\n        pointer-events: none;\n    }\n\n    &__wrapper {\n        position: relative;\n        z-index: 2;\n        display: grid;\n        grid-template-columns: 1.1fr 0.9fr;\n        width: 100%;\n        max-width: 1100px;\n        gap: 40px;\n        align-items: center;\n\n        @media (max-width: $breakpoint-lg) {\n            grid-template-columns: 1fr;\n            max-width: 600px;\n        }\n    }\n\n    &__info {\n        color: #fff;\n        padding-right: 40px;\n\n        @media (max-width: $breakpoint-lg) {\n            padding-right: 0;\n            text-align: center;\n        }\n    }\n\n    &__eyebrow {\n        display: inline-block;\n        font-size: 12px;\n        font-weight: 800;\n        letter-spacing: .16em;\n        text-transform: uppercase;\n        color: $color-primary;\n        margin-bottom: 12px;\n    }\n\n    &__title {\n        font-size: 52px;\n        font-weight: 800;\n        line-height: 1.02;\n        letter-spacing: -.04em;\n        margin: 0 0 20px;\n        color: #fff;\n\n        @media (max-width: $breakpoint-sm) {\n            font-size: 36px;\n        }\n    }\n\n    &__description {\n        font-size: 18px;\n        line-height: 1.7;\n        color: rgba(255, 255, 255, 0.9);\n        max-width: 480px;\n\n        @media (max-width: $breakpoint-lg) {\n            margin: 0 auto;\n        }\n    }\n\n    &__separator {\n        width: 60px;\n        height: 2px;\n        background-color: $color-primary;\n        margin: 32px 0;\n\n        @media (max-width: $breakpoint-lg) {\n            margin: 32px auto;\n        }\n    }\n\n    &__footer-text {\n        font-size: 14px;\n        line-height: 1.6;\n        color: rgba(255, 255, 255, 0.7);\n    }\n\n    &__link {\n        color: $color-primary;\n        text-decoration: none;\n        font-weight: 700;\n        transition: opacity 0.2s;\n\n        &:hover {\n            opacity: 0.8;\n            text-decoration: underline;\n        }\n    }\n\n    &__card {\n        background: rgba(247, 244, 239, 0.94);\n        border: 1px solid rgba(19, 35, 29, 0.1);\n        border-radius: 24px;\n        box-shadow: 0 18px 48px rgba(19, 35, 29, 0.14);\n        backdrop-filter: blur(12px);\n        padding: 24px 20px;\n        width: 100%;\n        max-width: 420px;\n        margin: 0 auto;\n\n        @media (max-width: $breakpoint-sm) {\n            padding: 24px 20px;\n            background: rgba(247, 244, 239, 0.98);\n        }\n    }\n}\n\n// Sub-bloque Formulario\n.form {\n    display: grid;\n    gap: 10px;\n\n    &__copy {\n        margin: 0 0 8px;\n        color: rgba(19, 35, 29, 0.78);\n        font-size: 14px;\n        line-height: 1.5;\n        text-align: left;\n    }\n\n    &__field-group {\n        display: flex;\n        flex-direction: column;\n    }\n\n    &__input {\n        width: 100%;\n        min-height: 48px;\n        border-radius: 14px;\n        border: 1px solid rgba(19, 35, 29, 0.12);\n        background: #fff;\n        padding: 0 14px;\n        color: #13231d;\n        font-size: 14px;\n        line-height: 1.4;\n        transition: all 0.2s ease;\n        outline: none;\n\n        &::placeholder {\n            color: rgba(19, 35, 29, 0.44);\n        }\n\n        &:focus {\n            border-color: $color-primary;\n            box-shadow: 0 0 0 4px rgba(130, 177, 148, 0.16);\n        }\n\n        &--textarea {\n            padding-top: 14px;\n            resize: none;\n            min-height: 100px;\n        }\n\n        &--error {\n            border-color: $color-error !important;\n            background-color: rgba($color-error, 0.02);\n\n            &:focus {\n                box-shadow: 0 0 0 4px rgba(201, 92, 92, 0.12) !important;\n            }\n        }\n\n        &:-webkit-autofill {\n            -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;\n            -webkit-text-fill-color: #13231d !important;\n            transition: background-color 5000s ease-in-out 0s;\n        }\n\n        &:-webkit-autofill:focus {\n            -webkit-box-shadow: 0 0 0 1000px #e6ebe4 inset !important;\n            -webkit-text-fill-color: #13231d !important;\n        }\n    }\n\n    &__error-text {\n        color: $color-error;\n        font-size: 11px;\n        margin-top: 4px;\n        margin-left: 4px;\n        font-weight: 700;\n        text-align: left;\n        animation: fadeIn 0.2s ease-in-out;\n    }\n\n    &__button {\n        width: 100%;\n        margin-top: 10px;\n        min-height: 48px;\n        padding: 0 24px;\n        border-radius: 16px;\n        font-weight: 750;\n        border: 1px solid transparent;\n        background: $color-primary;\n        color: #fff;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        font-family: inherit;\n        font-size: 15px;\n\n        &:hover:not(:disabled) {\n            background: $color-primary-hover;\n            transform: translateY(-1px);\n        }\n\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n    }\n\n    &__message--error {\n        color: $color-error;\n        font-size: 13px;\n        margin-top: 5px;\n        text-align: center;\n        font-weight: 600;\n    }\n}\n\n.success {\n    text-align: center;\n    padding: 20px 0;\n\n    &__icon {\n        color: $color-primary;\n        margin-bottom: 16px;\n\n        svg {\n            font-size: 64px;\n        }\n    }\n\n    &__title {\n        font-size: 28px;\n        font-weight: 800;\n        color: $text-main;\n        margin-bottom: 12px;\n        letter-spacing: -0.02em;\n    }\n\n    &__text {\n        font-size: 16px;\n        line-height: 1.6;\n        color: $text-secondary;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-5px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact": `ContactPage_contact__onJdA`,
	"contact__wrapper": `ContactPage_contact__wrapper__86THz`,
	"contact__info": `ContactPage_contact__info__ISav4`,
	"contact__eyebrow": `ContactPage_contact__eyebrow__dLjAb`,
	"contact__title": `ContactPage_contact__title__9Jgmz`,
	"contact__description": `ContactPage_contact__description__EIBH2`,
	"contact__separator": `ContactPage_contact__separator__l1hzd`,
	"contact__footer-text": `ContactPage_contact__footer-text__0x083`,
	"contact__link": `ContactPage_contact__link__ku5zm`,
	"contact__card": `ContactPage_contact__card__Vr1uT`,
	"form": `ContactPage_form__P3nUW`,
	"form__copy": `ContactPage_form__copy__1OO6N`,
	"form__field-group": `ContactPage_form__field-group__3k7d7`,
	"form__input": `ContactPage_form__input__7Obr7`,
	"form__input--textarea": `ContactPage_form__input--textarea__U8NOz`,
	"form__input--error": `ContactPage_form__input--error__T42o1`,
	"form__error-text": `ContactPage_form__error-text__sSyFp`,
	"fadeIn": `ContactPage_fadeIn__kUoRg`,
	"form__button": `ContactPage_form__button__E4mnC`,
	"form__message--error": `ContactPage_form__message--error__rQJxF`,
	"success": `ContactPage_success__--32Q`,
	"success__icon": `ContactPage_success__icon__uKnoA`,
	"success__title": `ContactPage_success__title__bY9-k`,
	"success__text": `ContactPage_success__text__fMmKt`
};
export default ___CSS_LOADER_EXPORT___;
